<div class="location-picker" (clickOutside)="closeLocationPicker()" [exclude]="clickOutsideExclude">
  <div class="location-picker-search">
    <label class="location-picker-search-label">{{'Search Address' | translate}}</label>
    <div #addressSearchContainer class="location-picker-search-container"></div>
    <span class="location-picker-hint">{{'Click on the map to place the marker' | translate}}</span>
  </div>
  <div #gMap class="map-container"></div>
</div>
